/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import { setPagination } from "../../../utils/helpers/pagination";

export default {
  SET_LIST(state, data) {
    state.list = data.items;
    if (data && data.pagination) {
      state.pagination = { ...state.pagination, ...data.pagination };
    }
  },
  SET_DETAIL(state, student) {
    state.selecting = student;
  },
  SET_LIST_DEMO(state, data) {
    state.demos = data.data;
    state.demoPagination.from = data.from;
    state.demoPagination.to = data.to;
    state.demoPagination.total = data.total;
    state.demoPagination.current_page = data.current_page;
    state.demoPagination.per_page = data.per_page;
  },
  SET_PER_PAGE_DEMO(state, data) {
    state.demoPagination.per_page = data;
  },
  SET_CURRENT_PAGE_DEMO(state, data) {
    state.demoPagination.current_page = data;
  },
  ADD_STUDENT(state, student) {
    state.list.push(student);
  },
  UPDATE_STUDENT(state, student) {
    const userIndex = state.list.findIndex((u) => u.id === student.id);
    if (userIndex >= 0) Object.assign(state.students[userIndex], student);
  },
  REMOVE_RECORD(state, itemId) {
    if (Array.isArray(itemId)) {
      itemId.forEach((item) => {
        const userIndex = state.list.findIndex((u) => u.id === item);
        state.list.splice(userIndex, 1);
      });
    } else {
      const userIndex = state.list.findIndex((u) => u.id === itemId);
      state.list.splice(userIndex, 1);
    }

    state.pagination = setPagination(state.pagination, itemId);
  },

  SET_COURSES(state, data) {
    state.courses = data;
  },

  //Classes sẽ được loại bỏ những class có group_id
  SET_CLASSES(state, data) {
    state.classes = data.items;
    state.classesWithoutGroups = data.items.filter((item) => {
      return item.group_id === null || item.group_id === undefined;
    });
  },
};
